module.exports = "/fonts/hashed/NotoSansSC-Medium.e5eed8b5.ttf.gz.bin";